import { colorTokens } from "./color-tokens";
export var shadows = {
  interactive: {
    focus: "inset 0 0 0 1px ".concat(colorTokens.border.interactive.focused)
  }
};